class LineItemRequest {
  constructor(...args) {
    if (args.length === 1) {
      this.skuId = args[0].skuId;
      this.externalId = args[0].externalId;
      this.presaleId = args[0].presaleId;
      this.releaseId = args[0].releaseId;
      this.lineItemProperties = args[0].lineItemProperties;
      this.currency = args[0].currency;
      this.country = args[0].country;
      this.quantity = args[0]?.quantity ?? 1;
    } else {
      const [
        skuId,
        externalId,
        presaleId,
        releaseId,
        lineItemProperties,
        currency,
        country,
        quantity,
      ] = args;
      this.skuId = skuId;
      this.externalId = externalId;
      this.presaleId = presaleId;
      this.releaseId = releaseId;
      this.lineItemProperties = lineItemProperties;
      this.currency = currency;
      this.country = country;
      this.quantity = quantity;
    }

    if (!(this.skuId && this.presaleId && this.releaseId)) {
      throw new Error('Could not create line item');
    }
  }

  toObj() {
    return {
      skuId: this.skuId,
      externalId: this.externalId,
      presaleId: this.presaleId,
      releaseId: this.releaseId,
      lineItemProperties: this.lineItemProperties,
      currency: this.currency,
      country: this.country,
      quantity: this.quantity,
    };
  }
}

export default LineItemRequest;
